/**
 * Сегмент пути для задачи: url_ref с API или slug, иначе числовой id.
 */
export function taskNavRef(task) {
  if (!task) return '';
  if (task.url_ref != null && String(task.url_ref).trim() !== '') {
    return String(task.url_ref).trim();
  }
  if (task.slug != null && String(task.slug).trim() !== '') {
    return String(task.slug).trim();
  }
  return task.id != null ? String(task.id) : '';
}
